import angular from 'angular';

import newRelicServiceModule from './NewRelicService';
import constantsModuleName from '../constants';
import {
  LOGS_DISABLE_ERRORS,
  LOGS_DISABLE_INFO,
} from "../constants";

class LogService {
  constructor($log, $window, DEBUG, NewRelicService) {
    this.$log = $log;
    this.$window = $window;
    this.DEBUG = DEBUG;
    this.NewRelicService = NewRelicService;
    this._console = $window && $window.console || console || { log: () => undefined } ;

    const logMethods = [
      'log',
      'warn',
      'info',
      'dir',
      'trace',
    ];
    const debugOnlyLogMethods = [
      'debug',
    ];
    const errorMethods = [
      'error',
    ];

    /**
     * Setup log method for a given name; attempts to bind to the console method, if it exists, otherwise
     * falls back to console.log()
     * @param name
     */
    const setupLogMethod = name => {
      if (LOGS_DISABLE_INFO) {
        return stubLogMethod(name);
      }
      let consoleMethod = this.console[name];
      if (!consoleMethod) {
        consoleMethod = this.console.log;
      }
      this[name] = consoleMethod.bind(this.console);
    };

    /**
     * Use no-op in place of log method
     * @param name
     */
    const stubLogMethod = name => {
      this[name] = () => {};
    };

    /**
     * Setup error method for given name; uses normal console.error handling, and also
     * passes error to NewRelicService.noticeError()
     * @param name
     */
    const setupErrorMethod = name => {
      if (LOGS_DISABLE_ERRORS) {
        return stubLogMethod(name);
      }
      let consoleMethod = this.console[name];
      if (!consoleMethod) {
        consoleMethod = this.console.error || this.console.log;
      }
      this[name] = (...args) => {
        // First display error message
        consoleMethod.apply(this.console, args);

        // Log to New Relic
        try {
          this.NewRelicService.noticeError(...args);
        } catch (e) {
          this.debug("Error communicating with New Relic:", e);
        }

      };
    };

    // Setup all log methods
    logMethods.forEach(setupLogMethod);

    // Only setup debug log methods in debug mode
    if (this.DEBUG) {
      debugOnlyLogMethods.forEach(setupLogMethod);
    } else {
      debugOnlyLogMethods.forEach(stubLogMethod);
    }

    // Setup all error methods
    errorMethods.forEach(setupErrorMethod);
  }

  get console() {
    return this._console;
  }

  handleException(...args) {
    return this.error(...args);
  }

  stringify(obj) {
    let str;
    try {
      str = JSON.stringify(obj);
    } catch (e) {
      this.warn("Error with stringify:", e);
    }
    return str;
  }

  stringifyAndParse(obj) {
    let result;
    if (obj) {
      let str = this.stringify(obj);
      if (str) {
        try {
          result = JSON.parse(str);
        } catch (e) {
          this.warn("Error parsing stringified object. Error:", e, "string:", str, "object:", obj);
        }
      }
    } else {
      result = obj;
    }
    return result;
  }
}

const moduleName = 'recaps.services.LogService';
const module = angular.module(moduleName, [
  newRelicServiceModule.name,
  constantsModuleName,
]);
module.service('LogService', LogService);
module.factory('$exceptionHandler', ($window, LogService) => {
  const myExceptionHandler = (exception, cause) => {
    LogService.handleException(exception, cause);
  };
  return myExceptionHandler;
});

export default module;
